import { IRankingRepository } from '../interfaces';
import LogUtil from '../../../core/utils/LogUtil';

export class RankingRepositoryImpl extends IRankingRepository {
  constructor(apiClient) {
    super();
    this.apiClient = apiClient;
  }

  async getSupplementsRanking(params = {}) {
    try {
      const response = await this.apiClient.get('/supplements/ranking', { params });
      return response;
    } catch (error) {
      LogUtil.error('[RankingRepository] 건강식품 랭킹 조회 실패:', error);
      throw error;
    }
  }

  async getMedicationsRanking(params = {}) {
    try {
      const response = await this.apiClient.get('/general-medications/ranking', { params });
      return response;
    } catch (error) {
      LogUtil.error('[RankingRepository] 일반의약품 랭킹 조회 실패:', error);
      throw error;
    }
  }

  async getProductRanking(params = {}) {
    try {
      return await this.apiClient.get('/insight/product-ranking', { params });
    } catch (error) {
      LogUtil.error('[RankingRepository] 인사이트 상품 랭킹 조회 실패:', error);
      throw error;
    }
  }

  async getProductTrend(productId, params = {}) {
    try {
      return await this.apiClient.get(`/insight/product-trend/${productId}`, { params });
    } catch (error) {
      LogUtil.error('[RankingRepository] 인사이트 상품 순위 추이 조회 실패:', error);
      throw error;
    }
  }

  async getSearchTrend(params = {}) {
    try {
      return await this.apiClient.get('/insight/search-trend', { params });
    } catch (error) {
      LogUtil.error('[RankingRepository] 카테고리 검색 트렌드 조회 실패:', error);
      throw error;
    }
  }

  async getHighlights() {
    try {
      return await this.apiClient.get('/insight/highlights');
    } catch (error) {
      LogUtil.error('[RankingRepository] 주목할 변화 조회 실패:', error);
      throw error;
    }
  }

  async getProductDetail(productId) {
    try {
      return await this.apiClient.get(`/insight/product-detail/${productId}`);
    } catch (error) {
      LogUtil.error('[RankingRepository] 상품 상세(건기식 정보) 조회 실패:', error);
      throw error;
    }
  }

  // GET /insight/my-products?q=&page=&limit= — 최근 60일 우리 약국 판매 상품(전문의약품 제외), 판매량 순 (백엔드 10/22)
  async getMyProducts(params = {}) {
    try {
      return await this.apiClient.get('/insight/my-products', { params });
    } catch (error) {
      LogUtil.error('[RankingRepository] 우리 약국 판매 상품 조회 실패:', error);
      throw error;
    }
  }
}
